export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #aeaeae",
    boxShadow: "none",
    borderRadius: "4px",
    background: "#ffffff",
    minHeight: "44px",
    fontSize: "14px",
    cursor: "pointer",
    width: "100%",
    minWidth: "220px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 4,
    cursor: "pointer",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "46px",
    cursor: "pointer",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  option: (provided, state) => ({
    ...provided,
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#1F61C5"
      : state.isFocused
      ? "#e6f0ff"
      : "#ffffff",
    color: state.isSelected ? "#ffffff" : "#002147",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#002147",
    fontSize: "14px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "calc(100% - 20px)",
  }),
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};
